// Validating the JSA basic info

// JSA is not required to be filled out, but we do need to validate some of the fields to make sure that bad data is not sent to the backend causing errors.
// We need to check teh time completed, data completed, and ewi supervisor information.

export const validateJsaBasicInfoDraft = (jsaBasicInfo) => {
  const errors = {};
  console.log("JSA Basic Info Draft:", jsaBasicInfo);

  const militaryTimeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
  // Validating the time completed
  if (
    jsaBasicInfo.jsaCompletedTime &&
    jsaBasicInfo.jsaCompletedTime.trim() !== ""
  ) {
    if (!militaryTimeRegex.test(jsaBasicInfo.jsaCompletedTime)) {
      errors.jsaCompletedTime = "Time completed is not in the correct format";
    }
  }

  // Validate that the completed date (if provided) is in yyyy-mm-dd format
  const yyyymmddRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
  if (
    jsaBasicInfo.jsaCompletedDate &&
    jsaBasicInfo.jsaCompletedDate.trim() !== ""
  ) {
    if (!yyyymmddRegex.test(jsaBasicInfo.jsaCompletedDate)) {
      errors.jsaCompletedDate = "Date is not in the correct format";
    }
  }
  console.log("Errors:", errors);
  return errors;
};

export const validateJsaBasicInfoSubmitted = (jsaBasicInfo) => {
  const errors = {};
  console.log("JSA Basic Info:", jsaBasicInfo);
  // Validating EWI Supervisor information
  if (
    !jsaBasicInfo.supervisor ||
    !jsaBasicInfo.supervisor?.value ||
    jsaBasicInfo.supervisor?.value.trim() === ""
  ) {
    errors.supervisor = "Supervisor data is not correct";
  }
  const militaryTimeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
  // Validating the time completed
  if (!jsaBasicInfo.jsaCompletedTime) {
    errors.jsaCompletedTime = "Time completed is required";
  } else if (!militaryTimeRegex.test(jsaBasicInfo.jsaCompletedTime)) {
    errors.jsaCompletedTime = "Time completed is not in the correct format";
  }

  // Validate that the completed date (if provided) is in yyyy-mm-dd format
  const yyyymmddRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
  if (
    !jsaBasicInfo.jsaCompletedDate ||
    jsaBasicInfo.jsaCompletedDate.trim() === ""
  ) {
    errors.jsaCompletedDate = "Date completed is required";
  } else if (!yyyymmddRegex.test(jsaBasicInfo.jsaCompletedDate)) {
    errors.jsaCompletedDate = "Date is not in the correct format";
  }
  console.log("Errors:", errors);
  return errors;
};
